export default {
  // Basic Information
  基本信息: "ข้อมูลพื้นฐาน",
  商单名称: "ชื่อแคมเปญ",
  请输入商单名称: "กรุณาป้อนชื่อคำสั่งซื้อ",
  最多可输入50个字符: "สูงสุด 50 ตัวอักษร",
  请输入: "กรุณาป้อน",
  商单总预算: "งบทั้งหมดของแคมเปญ",
  支付给达人的目标预算: "เป้าหมายงบประมาณสำหรับครีเอเตอร์",
  请输入商单总预算: "กรุณาป้อนงบประมาณทั้งหมด",
  仅可输入数字和小数点: "ป้อนได้เฉพาะตัวเลขและจุดทศนิยม",
  预计报名时间: "เวลาลงทะเบียนที่คาดการณ์",
  请选择预计报名时间: "กรุณาเลือกเวลาลงทะเบียนที่คาดการณ์",
  预计交付时间: "เวลาส่งมอบที่คาดการณ์",
  请选择预计交付时间: "กรุณาเลือกเวลาส่งมอบที่คาดการณ์",
  提交: "ส่ง",

  // Brand Introduction
  品牌介绍: "แนะนำแบรนด์",
  "向达人更好地了解品牌，提升接单可能性":
    "ช่วยให้ครีเอเตอร์เข้าใจแบรนด์ได้ดีขึ้นและเพิ่มโอกาสในการรับงาน",
  品牌名称: "ชื่อแบรนด์",
  品牌Logo: "โลโก้แบรนด์",
  请上传文件: "กรุณาอัปโหลดไฟล์",
  "支持扩展名：.jpg .png…": "รองรับนามสกุลไฟล์: .jpg .png…",
  请输入备注: "กรุณาป้อนหมายเหตุ",

  // Creator Requirements
  达人要求: "ข้อกำหนดของครีเอเตอร์",
  满足设置要求的达人才可参加商单并申样:
    "เฉพาะครีเอเตอร์ที่ตรงตามข้อกำหนดเท่านั้นที่สามารถเข้าร่วมและขอตัวอย่างได้",
  粉丝量级: "ระดับผู้ติดตาม",
  "粉丝量≥": "ผู้ติดตาม ≥",
  仅支持输入整数: "ป้อนได้เฉพาะจำนวนเต็ม",
  请输入粉丝量: "กรุณาป้อนจำนวนผู้ติดตาม",
  目标达人数: "จำนวนครีเอเตอร์เป้าหมาย",
  请输入目标达人数: "กรุณาป้อนจำนวนครีเอเตอร์เป้าหมาย",
  "商单预算/人": "งบประมาณต่อครีเอเตอร์",
  请输入商单预算: "กรุณาป้อนงบประมาณคำสั่งซื้อ",

  // Product Information
  商单商品: "สินค้าคำสั่งซื้อ",
  商品信息: "ข้อมูลสินค้า",
  修改商品: "แก้ไขสินค้า",
  添加商品: "เพิ่มสินค้า",
  "达人佣金%": "คอมมิชชั่นครีเอเตอร์ %",
  "Youpik佣金%": "คอมมิชชั่น Youpik %",
  商品ID: "รหัสสินค้า",
  所属店铺: "ร้านค้า",
  店铺短码: "รหัสร้านค้า",
  库存: "สินค้าคงเหลือ",
  佣金: "คอมมิชชั่น",
  商品内容不能为空: "เนื้อหาสินค้าไม่สามารถเว้นว่างได้",

  // Script and Video
  脚本范例: "ตัวอย่างสคริปต์",
  请选择脚本范例: "กรุณาเลือกตัวอย่างสคริปต์",
  请输入文案链接: "กรุณาป้อนลิงก์เนื้อหา",
  请输入有效链接: "กรุณาป้อนลิงก์ที่ถูกต้อง",
  添加脚本范例: "เพิ่มตัวอย่างสคริปต์",
  参考视频: "วิดีโออ้างอิง",
  参考视频类型: "ประเภทวิดีโออ้างอิง",
  请选择视频类型: "กรุณาเลือกประเภทวิดีโอ",
  本地视频: "วิดีโอท้องถิ่น",
  TikTok视频链接: "ลิงก์วิดีโอ TikTok",
  请输入视频链接: "กรุณาป้อนลิงก์วิดีโอ",
  "请输入 TikTok 视频链接": "กรุณาป้อนลิงก์วิดีโอ TikTok",
  添加参考视频: "เพิ่มวิดีโออ้างอิง",

  // Commercial Order List
  video: "วิดีโอ",
  Live: "ไลฟ์",
  LiveAndVideo: "ไลฟ์และวิดีโอ",
  进行中: "กำลังดำเนินการ",
  已交付: "ส่งแล้ว",
  已取消: "ยกเลิกแล้ว",
  复制商单: "คัดลอก",
  编辑商单: "แก้ไข",
  交付商单: "ส่งมอบ",
  取消商单: "ยกเลิก",
  商单编号: "ID แคมเปญ",
  当前预估支出: "การใช้จ่ายปัจจุบันโดยประมาณ",
  实际支出: "การใช้จ่ายจริง",
  粉丝数k: "ผู้ติดตาม ≥{num}",
  接单达人数: "จำนวนครีเตอร์ที่รับงาน",
  交付视频数: "จำนวนวิดีโอที่ส่งมอบ",
  商单PM: "PM แคมเปญ",
  创建时间: "เวลาสร้าง",
  交付时间: "เวลาส่ง",
  交付人: "ผู้ส่งมอบ",
  分享商单: "แชร์คำสั่งซื้อ",
  进入工作台: "เข้าสู่พื้นที่ทำงาน",
  新增商单: "เพิ่มคำสั่งซื้อ",
  查看进度: "ดูความคืบหน้า",
  工作台: "พื้นที่ทำงาน",
  查看详情: "ดูรายละเอียด",
  总预算: "งบประมาณทั้งหมด",
  交付要求: "ข้อกำหนดการส่งมอบ",
  交付内容: "เนื้อหาการส่งมอบ",
  TAP挂链: "ลิงก์ TAP",
  视频: "วิดีโอ",
  必须: "จำเป็น",
  非必须: "ไม่จำเป็น",
  "Ads Code": "รหัสโฆษณา",
  内容数量: "จำนวนเนื้อหา",
  内容时长: "ระยะเวลาเนื้อหา",
  秒: "วินาที",
  Hashtag: "แฮชแท็ก",
  添加: "เพิ่ม",
  添加商单商品: "เพิ่มสินค้าคำสั่งซื้อ",
  商品: "สินค้า",
  商品名称: "ชื่อสินค้า",
  商品价格: "ราคาสินค้า",
  人: "คน",
  份: "ชุด",
  活动ID: "รหัสแคมเปญ",
  商家短码: "รหัสย่อผู้ค้า",
  商家名称: "ชื่อผู้ค้า",
  活动: "แคมเปญ",
  可用: "ใช้ได้",
  不可用: "ใช้ไม่ได้",
  状态: "สถานะ",
  商家: "ผู้ค้า",
  目标接单达人: "อินฟลูเอนเซอร์เป้าหมาย",
  邀约达人时间: "เวลาการเชิญ",
  "平均预算/达人": "งบประมาณเฉลี่ย/คน",
  目标总预算: "งบประมาณรวมเป้าหมาย",
  目标交付时间: "เวลาส่งมอบเป้าหมาย",
  预算把控: "ควบคุมงบประมาณ",
  目标预算: "งบประมาณเป้าหมาย",
  "该商单开始时PM设置的总达人预算。": "งบประมาณรวมที่ PM ตั้งไว้เมื่อเริ่มต้นคำสั่งซื้อ",
  预计支出: "ค่าใช้จ่ายที่คาดไว้",
  "已接单达人的最终报价之和。": "ราคารวมสุดท้ายของอินฟลูเอนเซอร์ที่รับงาน",
  "商单完结后,已接单达人的最终报价之和,未完结前计为0。":
    "หลังคำสั่งเสร็จสิ้น รวมราคาสุดท้ายที่รับงาน, ก่อนหน้านั้นนับเป็น 0",
  达人进度: "ความคืบหน้าอินฟลูเอนเซอร์",
  邀约达人数: "จำนวนคนที่เชิญ",
  申样达人数: "จำนวนคนขอตัวอย่าง",
  交付达人数: "จำนวนคนส่งมอบ",
  已打款达人数: "จำนวนคนที่ชำระเงินแล้ว",
  内容进度: "ความคืบหน้าเนื้อหา",
  目标内容数: "จำนวนเนื้อหาเป้าหมาย",
  内容交付: "เนื้อหาที่ส่งแล้ว",
  合格内容: "เนื้อหาผ่านเกณฑ์",
  不合格内容: "เนื้อหาไม่ผ่าน",
  交付效果: "ประสิทธิภาพการส่งมอบ",
  总播放量: "ยอดเข้าชมรวม",
  总点赞数: "จำนวนไลก์รวม",
  总评论数: "จำนวนคอมเมนต์รวม",
  总销售件数: "ยอดขายรวม",
  商单交付提醒: "แจ้งเตือนการส่งคำสั่งซื้อ",
  "交付后达人无法进行邀请、接单、申样、履约等操作":
    "หลังส่งมอบ อินฟลูเอนเซอร์จะไม่สามารถเชิญ รับงาน ขอทดลอง หรือดำเนินการอื่นๆ ได้",
  "，你还要继续吗？": " คุณต้องการดำเนินการต่อหรือไม่?",
  商单取消提醒: "แจ้งเตือนการยกเลิกคำสั่งซื้อ",
  "取消后达人无法进行邀请、接单、申样、履约等操作":
    "หลังจากยกเลิก อินฟลูเอนเซอร์จะไม่สามารถเชิญ รับงาน ขอทดลอง หรือดำเนินการได้",
  取消时间: "เวลายกเลิก",
  操作人: "ผู้ดำเนินการ",
  全部PIC: "ผู้รับผิดชอบทั้งหมด",
  "最多只能上传 {maxLength} 个文件": "สามารถอัปโหลดไฟล์ได้ไม่เกิน {maxLength} ไฟล์",
  确认提交: "ยืนยันการส่ง",
  修改后达人邀请信息将同步修改: "ข้อมูลคำเชิญของอินฟลูเอนเซอร์จะถูกแก้ไขให้ตรงกันหลังการแก้ไข",
  仅支持输入数字和小数点: "รองรับเฉพาะตัวเลขและจุดทศนิยมเท่านั้น",
  "达人发布内容后，将以该要求做为检测合格的标准":
    "หลังจากผู้มีอิทธิพลโพสต์เนื้อหา ข้อกำหนดนี้จะถูกใช้เป็นเกณฑ์การตรวจสอบ",
  链接无效: "ลิงก์ไม่ถูกต้อง",
  视频链接重复: "ลิงก์วิดีโอซ้ำ",
  adsCode码重复: "รหัส Ads ซ้ำ",
  合格: "ผ่านเกณฑ์",
  不合格: "ไม่ผ่านเกณฑ์",
  前往商家工作台: "ไปยังแดชบอร์ดแคมเปญ",
  履约内容: "เนื้อหาการปฏิบัติตาม",
  未在规定时间内发布合格内容: "ไม่ได้โพสต์เนื้อหาที่ผ่านเกณฑ์ภายในเวลาที่กำหนด",
  商单履约内容不合格: "เนื้อหาการปฏิบัติตามคำสั่งซื้อไม่ผ่านเกณฑ์",
  待审核: "รอตรวจสอบ",
  Hashtag错误: "Hashtag ผิดพลาด",
  "TAP link未挂链": "ลิงก์ TAP ไม่ได้เชื่อมต่อ",
  视频时长未达标: "ระยะเวลาวิดีโอไม่ผ่านเกณฑ์",
  "Ads Code未填或填写错误": "รหัส Ads ไม่ได้กรอกหรือกรอกผิด",
  商单履约失败: "การปฏิบัติตามคำสั่งซื้อไม่สำเร็จ",
  请输入有效的URL链接: "กรุณาป้อนลิงก์ URL ที่ถูกต้อง",
  "请输入 Ads code": "กรุณาป้อนรหัสโฆษณา",
  "仅可输入数字和小数点，最多两位小数":
    "อนุญาตให้ป้อนตัวเลขและจุดทศนิยมเท่านั้น, มากที่สุดสองตำแหน่งทศนิยม",
  确认创建: "ยืนยันการสร้าง",
  视频不大于50M: "วิดีโอไม่ควรเกิน 50 มегаไบต์",
  图片不大于5M: "รูปภาพไม่ควรเกิน 5 มегаไบต์",
  内容: "เนื้อหา",
  查看数据: "ดูข้อมูล",
  最多添加10个标签: "คุณสามารถเพิ่มแท็กได้สูงสุด 10 แท็ก",
  仅可输入整数: "อนุญาตให้ป้อนตัวเลขจำนวนเต็มเท่านั้น",
  总订单数: "จำนวนคำสั่งซื้อทั้งหมด",
  返回: "กลับ",
  单: "ใบสั่ง",
  "符合以上粉丝量级的接受商单目标达人人数。":
    "จำนวนครีเอเตอร์เป้าหมายที่มีจำนวนผู้ติดตามตามระดับที่กำหนดและยอมรับงาน",
  "和达人谈单时不可超过该预算。": "ห้ามเกินงบประมาณนี้เมื่อตกลงงานกับครีเอเตอร์",
  确认取消保存: "ยืนยันยกเลิกการบันทึก",
  取消后编辑的内容将不会保存: "ข้อมูลที่แก้ไขจะไม่ถูกบันทึก ต้องการดำเนินการต่อไหม"
};
